import { render, staticRenderFns } from "./OListItem.vue?vue&type=template&id=55d82e0c&"
import script from "./OListItem.vue?vue&type=script&lang=js&"
export * from "./OListItem.vue?vue&type=script&lang=js&"
import style0 from "./OListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports